//#region IMPORT
import React, { useEffect } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { useSelector } from 'react-redux';
import M_WOS_BASICF from '../M_WOS_BASIC/M_WOS_BASICF';
import M_WOS_BASIC_01F from '../M_WOS_BASIC_01/M_WOS_BASIC_01F';
//#endregion

export default function M_Master_BASIC({ activeTab, setActiveTab }) {
  const { stopWorking } = useSelector((state) => state.workingCheck);
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const isEmtUser = String(userInfo?.emtYn ?? '').toUpperCase() === 'Y';
  const showSituationDot = stopWorking === 1;

  useEffect(() => {
    if (!isEmtUser && activeTab !== 0) {
      setActiveTab(0);
    }
  }, [isEmtUser, activeTab, setActiveTab]);

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {isEmtUser && (
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={activeTab}
            onChange={(e, newValue) => setActiveTab(newValue)}
            variant="fullWidth"
            sx={{
              '& .MuiTab-root': {
                fontSize: '14px',
                fontWeight: 'bold',
                color: '#9E9E9E',
              },
              '& .Mui-selected': {
                color: '#33ABD1 !important',
              },
              '& .MuiTabs-indicator': {
                backgroundColor: '#33ABD1',
              },
            }}
          >
            <Tab
              label={
                <Box
                  component="span"
                  sx={{
                    display: 'inline-block',
                    position: 'relative',
                    pr: 0.75,
                  }}
                >
                  작업중지 접수
                  {showSituationDot && (
                    <Box
                      component="span"
                      className="alarm-icon-blink"
                      sx={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        width: 5,
                        height: 5,
                        borderRadius: '50%',
                        bgcolor: '#F55858',
                      }}
                      aria-hidden
                    />
                  )}
                </Box>
              }
            />
            <Tab label="작업중지 지시" />
          </Tabs>
        </Box>
      )}

      {/* 탭 콘텐츠 */}
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
        {(isEmtUser ? activeTab === 0 : true) && <M_WOS_BASICF />}
        {isEmtUser && activeTab === 1 && <M_WOS_BASIC_01F />}
      </Box>
    </Box>
  );
}
